import React from 'react';
import { Skeleton, Box, Typography } from '@mui/material';
import Avatar from '@mui/material/Avatar';
const SkeletonLayout = () => {
    return (
        <div style={{ display: 'flex', height: '100vh' }}>
            {/* Sidebar Skeleton */}
            <Box sx={{ width: 240, padding: 2 }}>
                <Skeleton variant="rectangular" height={"100vh"} />
                <Skeleton variant="rectangular" height={"100vh"} />
                <Skeleton variant="rectangular" height={"100vh"} />
            </Box>
            
            {/* Main Content Skeleton */}
            <Box sx={{ flexGrow: 1, padding: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Box sx={{ margin: 1 }}>
                        <Skeleton variant="circular">
                            <Avatar />
                        </Skeleton>
                    </Box>

                    <Box sx={{ width: '100%' }}>
                        <Skeleton width="100%">
                            <Typography>.</Typography>
                        </Skeleton>
                    </Box>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Skeleton variant="rectangular" width={"20%"} height={"100vh"} />
                    <Skeleton variant="rectangular" width="80%" height={"100vh"}>
                        <div style={{ paddingTop: '57%' }} />
                    </Skeleton>
                </Box>
            </Box>
        </div>
    );
};

export default SkeletonLayout;
